module.exports = __webpack_public_path__ + "static/bello-934400ae9342a148f68bb615a1bd9c31.png";